import { useStaticQuery, graphql } from "gatsby"

export default () => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
            defaultLanguage
            lsItemName
            buttonTarget
          }
        }
      }
    `
  )
  return site.siteMetadata
}
